import React, { useEffect } from "react";
import Redirect from "./Redirect";
import auth from "../services/auth";
import { toast } from "react-toastify";

const PrivateRoute = ({ children, setUser, user }: any) => {

    useEffect(() => {
        const SessionExists = () => {
            auth.getUser().catch((error) => {
                if (error?.code === "ERR_NETWORK") {
                    toast.error("Connection Error", {
                        theme: "colored",
                        hideProgressBar: false,
                    });
                    setUser(null);
                } else if (error?.response?.status === 401) {
                    toast.error("Session Ended", {
                        theme: "colored",
                        hideProgressBar: false,
                    });
                    setUser(null);
                }
            });
        };

        const interval = setInterval(() => {
            SessionExists();
        }, 181 * 1000);

        return () => clearInterval(interval);
    }, [setUser]);

    return user ? children : <Redirect />;
};

export default PrivateRoute;
